export const cartDetailsFragment = /* GraphQL */ `
  fragment cartDetails on Cart {
    id
    createdAt
    updatedAt
    checkoutUrl
    totalQuantity
    note
    attributes {
      key
      value
    }
    cost {
      totalAmount {
        amount
        currencyCode
      }
      subtotalAmount {
        amount
        currencyCode
      }
      totalTaxAmount {
        amount
        currencyCode
      }
      totalDutyAmount {
        amount
        currencyCode
      }
    }
    buyerIdentity {
      countryCode
      customer {
        id
        email
        firstName
        lastName
        numberOfOrders
        phone
      }
      purchasingCompany{
        company{
          id
          name
        }
        location{
          id
          name
        }
      }
    }
    discountAllocations{
      discountedAmount{
        amount
        currencyCode
      }
    }
    lines(first: 250) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          quantity
          attributes {
            key
            value
          }
          cost {
            amountPerQuantity {
              amount
              currencyCode
            }
            compareAtAmountPerQuantity {
              amount
              currencyCode
            }
            subtotalAmount {
              amount
              currencyCode
            }
            totalAmount {
              amount
              currencyCode
            }
          }
          discountAllocations {
            discountedAmount {
              amount
              currencyCode
            }
          }
          merchandise {
            ... on ProductVariant {
              id
              sku
              title
              availableForSale
              currentlyNotInStock
              requiresShipping
              quantityAvailable
              selectedOptions {
                name
                value
              }
              image {
                url
                altText
                width
                height
              }
              price {
                amount
                currencyCode
              }
              compareAtPrice {
                amount
                currencyCode
              }
              product {
                id
                handle
                title
                tags
                vendor
                productType
              }
              storeAvailability(first:50) {
                pageInfo {
                  hasNextPage
                  hasPreviousPage
                }
                edges {
                  node {
                    available
                    location {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
     
    }
  }
`;
const cartCreateMutation = /* GraphQL */ `
  mutation cartCreate($input: CartInput) {
    cartCreate(input: $input) {
      cart {
        ...cartDetails
      }
      userErrors {
        code
        field
        message
      }
    }
  }
  ${cartDetailsFragment}
`;
export default cartCreateMutation;
